import _ from 'underscore';
import templateStr from 'text!./request.html';

export default [function () {
    return {
        restrict: 'A',
        template: templateStr,

        scope: {},
        controller: ['$filter', '$scope', 'ActivityService', 'gatewayParamConfig', '$stateParams', function ($filter, $scope, ActivityService, gatewayParamConfig, $stateParams) {

            $scope.requestDataEmpty = false;
            var activitiesDataPromise = ActivityService.getActivitiesForPolicy($stateParams.policyNumber);

            activitiesDataPromise.then(function (res) {
                $scope.activityResponse = res;

                $scope.activityData = _.filter($scope.activityResponse, function (obj) {
                    return obj.activityPattern.code.includes('portal_act_') && !obj.activityPattern.code.includes('portal_act_esc_');
                }); //filter Request cancellation and reinstatement activities data for Request_MSF

                if ($scope.activityData == null || $scope.activityData == undefined || $scope.activityData.length == 0) {
                    $scope.requestDataEmpty = true;
                }
            });
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/RequestDirective_MSF/Request.js
// module id = 1766
// module chunks = 0